<script setup lang="ts">
withDefaults(defineProps<{ size?: number; showText?: boolean }>(), { size: 32, showText: true })
</script>

<template>
  <span class="app-logo">
    <svg :width="size" :height="size" viewBox="0 0 64 64" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id="ls-logo-gradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stop-color="#6366f1" />
          <stop offset="1" stop-color="#14b8a6" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="16" fill="url(#ls-logo-gradient)" />
      <rect x="14" y="36" width="8" height="14" rx="3" fill="#fff" />
      <rect x="28" y="24" width="8" height="26" rx="3" fill="#fff" />
      <rect x="42" y="14" width="8" height="36" rx="3" fill="#fff" opacity=".85" />
    </svg>
    <span v-if="showText" class="app-logo__text">Live Survey</span>
  </span>
</template>

<style scoped>
.app-logo {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.app-logo__text {
  font-weight: 750;
  letter-spacing: -0.01em;
  font-size: 1.05rem;
}
</style>
